// Vendors
import 'slick-carousel/slick/slick.min.js';
import videojs from 'video.js/dist/video.min.js';
import gsap from 'gsap'
import 'jquery.cookie/jquery.cookie.js'
import ScrollTrigger from 'gsap/ScrollTrigger'

// Pages
import {ArchiveProduct} from '../src/archive-product';
import {ArchiveArticle} from '../src/archive-article';
import {ArchivePressRelease} from '../src/archive-press-release';

export default {

    init() {

        let scroll = $(window).scrollTop();

        $(window).scroll(function () {
            scroll = $(window).scrollTop();
            posHeader();
        });

        // Blur on click
        $('a, button, input[type=\'submit\'], .btn').on('click', function () {
            $(this).blur();
        });


        // Button scroll down
        $('.js_btn-scroll').on('click', function (e) {
            e.preventDefault();
            $('html,body').stop().animate({
                scrollTop: $($(this).attr('href')).offset().top - $('.header-global-wrapper').outerHeight(true),
            }, 1000);
        });

        // ========================================
        // Header
        // ========================================
        function posHeader() {
            if (scroll > 0) {
                $('body').addClass('scroll');
            } else {
                $('body').removeClass('scroll');
            }
        }
        posHeader();

        $('.js_toggle-search').on('click', function() {
            if($('body').hasClass('menu-active')) {
                $('html').toggleClass('disable-scroll');
                $('.header-global-wrapper .btn-burger').toggleClass('close');
                $('body').toggleClass('menu-active');
            }
            $('body').toggleClass('search-active');
            $('.header-global-wrapper .btn-search').toggleClass('close');
            if ($('body').hasClass('search-active')) {
                setTimeout(function() {
                    $('.search-form .search-field').focus();
                }, 500);
            }
        });

        $(document).on('click', '#search-form', function (e) {
            if (e.target !== this) {
                return;
            }
            $('body').toggleClass('search-active');
            $('.header-global-wrapper .btn-search').toggleClass('close');
        });

        $('.js_toggle-menu').on('click', function () {
            if($('body').hasClass('search-active')) {
                $('body').toggleClass('search-active');
                $('.header-global-wrapper .btn-search').toggleClass('close');
            }
            $('.header-global-wrapper .btn-burger').toggleClass('close');
            $('html').toggleClass('disable-scroll');
            $('body').toggleClass('menu-active');
        });
        $('.js_toggle-accessibility').on('click', function() {
            $('.pojo-a11y-toolbar-toggle-link').trigger('click');
        });




        // ========================================
        // Modules
        // ========================================
        // Module Quotation
        $('.js_slider-quotation').slick({
            speed: 750,
            prevArrow: '<button type="button" class="arrow arrow-prev"></button>',
            nextArrow: '<button type="button" class="arrow arrow-next"></button>',
        });


        // Module Related post
        function initSliderRelatedPost (elt) {
            $(elt).slick({
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                dots: true,
                speed: 750,
                draggable: false,
                slidesToShow: 1,
                slidesToScroll: 3,
                centerMode: true,
                variableWidth: true,
                infinite: false,
                initialSlide: 1,
                responsive: [
                    {
                        breakpoint: 1150,
                        settings: {
                            initialSlide: 0,
                        }
                    },
                ],
            });
        }
        $('.js_slider-related-post').each(function (index) {
            let elt = this;
            if ($(elt).find('.item').length > 3) {
                initSliderRelatedPost(elt);
            } else if ($(elt).find('.item').length > 2) {
                if ($(window).width() < 1200) {
                    initSliderRelatedPost(elt);
                }
            } else if ($(elt).find('.item').length > 1) {
                if ($(window).width() < 750) {
                    initSliderRelatedPost(elt);
                }
            }
        });


        // Module FAQ
        $('.js_accordion-title').on('click', function() {
            $(this).toggleClass('active');
            $(this).next('.js_accordion-txt').slideToggle(400);
        });


        // Module Text image
        $('.module-text-image .video').each(function(index, el) {
            let video = '#video-' + index;
            $(el).attr('id', 'video-' + index);
            let playerVideo = videojs('video-' + index);
            $(video).on('mouseenter', function () {
                $(video).addClass('active');
                playerVideo.play();
            });
            $(video).on('mouseleave', function () {
                $(video).removeClass('active');
                playerVideo.pause();
            });
        });


        // Module Slider image
        $('.js_slider-image').slick({
            arrows: false,
            dots: true,
            speed: 750,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            infinite: false,
        });


        // Module Slider image texte
        $('.js_slider-image-text').slick({
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            dots: true,
            speed: 750,
            slidesToShow: 1,
            variableWidth: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                    }
                },
            ],
        });


        // Module Slider image texte 2
        $('.js_slider-image-text2').slick({
            arrows: true,
            prevArrow: '',
            nextArrow: '<button type="button" class="slick-next"></button>',
            speed: 750,
            infinite: true,
        });


        // Module Podcast
        $('.js_toggle-audio').on('click', function() {
            let $elt = $(this);
            let playerAudio = $elt.siblings('.js_player-audio');
            if ($elt.hasClass('pause')) {
                playerAudio[0].pause();
            } else {
                playerAudio[0].play();
            }
            $elt.toggleClass('pause');
        });
        $('.js_player-audio').on('ended', function() {
            $(this).siblings('.js_toggle-audio').toggleClass('pause');
        });


        // Module Pricing
        $('.js_toggle-price').on('click', function() {
            if(!$(this).hasClass('active')) {
                $('.js_toggle-price').removeClass('active');
                $(this).addClass('active');
                $('.js_price-type').toggle(0);
            }
        });


        // Module Tabs
        $('.js-btn-tab').on('click', function() {
            if (!$(this).hasClass('active')) {
                $('.js-btn-tab').removeClass('active');
                $(this).addClass('active');
                $('.js-content-tab').hide(0);
                $('.js-content-tab[data-index="' + $(this).data('index') + '"]').show(0);
                $('.iframe').each(function(index, el) {
                    $(el)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                });
            }
        });
        $('.js-video-tabs').on('click', function() {
            $(this).addClass('active');
            $(this).next('.iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        });


        // Module Form
        let textField = 'Choose file';
        if ($('html').attr('lang') == 'fr-FR') {
            textField = 'Choisir un fichier';
        }
        $('.module-form .ginput_container_fileupload').each(function (index, el) {
            $(el).attr('data-label', textField);
        });
        $('.module-form .ginput_container_fileupload input').on('change', function (e) {
            let fileName = e.target.value.split('\\').pop();
            let $el = $(this).closest('.ginput_container_fileupload');
            if (fileName == '') {
                $el.removeClass('active').attr('data-label', textField);
            } else {
                $el.addClass('active').attr('data-label', fileName);
            }
        });





        // ========================================
        // Popin vidéo
        // ========================================
        $('.js_open-popin-video').on('click', function() {
            if ($.cookie(window.rgpd_cookies.video) === 'yes') {
                let $iframe = $('.popin-wrapper iframe');
                let src = 'https://www.youtube-nocookie.com/embed/' + $(this).data('src') + '?rel=0&showinfo=0&enablejsapi=1&autoplay=1';
                $iframe.attr('src', src);
                $('.popin-wrapper .js-rgpd-no-consent').html('');
                $('.popin-wrapper').show(0).addClass('active');
                setTimeout(function () {
                    $iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                }, 500);
            }
            else {
                let $iframe = $('.popin-wrapper iframe');
                $iframe.attr('src', '');
                $('.popin-wrapper').show(0).addClass('active');
                var tpl = '<div style="width:100%; height:100%; position:absolute;top:0;left:0" class="wt-cli-iframe-placeholder"><div class="wt-cli-inner-text"><a class="cli_manage_current_consent" href="javascript:void(0)" style="position:relative;z-index:2">'+$('.popin-wrapper').attr('wt-cli-mention')+'</a></div></div>';
                $('.popin-wrapper .js-rgpd-no-consent').html(tpl);
            }
        });

        function closePopin() {
            let $iframe = $('.popin-wrapper iframe');
            $iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            $('.popin-wrapper').removeClass('active');
            setTimeout(function () {
                $('.popin-wrapper').hide(0);
            }, 500);
        }

        $(document).on('click', '.js_close-popin', function () {
            closePopin();
        });
        $(document).on('click', '.popin-wrapper', function (e) {
            if (e.target !== this) {
                return;
            }
            closePopin();
        });





        // ========================================
        // Pages
        // ========================================
        // Archive product
        $('.woocommerce-shop, .tax-product_cat').each(function () {
            new ArchiveProduct($(this));
        });


        // Archive article
        $('.page-archive-article').each(function () {
            new ArchiveArticle($(this));
        });

        // Archive press release
        $('.page-archive-press-release').each(function () {
            new ArchivePressRelease($(this));
        });


        // Single page product
        $('.js_slider-single-product').slick({
            arrows: false,
            fade: true,
            draggable: false,
            swipe: false,
        });
        $('.js_change-slide-single-product').on('click', function() {
            $('.js_slider-single-product').slick('slickGoTo', $(this).data('index-slide'));
        });


        // Contact
        $('.js_toggle-module-form').on('click', function() {
            $('.module-form').slideDown(400);
            $('html,body').stop().animate({
                    scrollTop: $('.module-form').offset().top - $('.header-global-wrapper').outerHeight(true),
                }, 750);
        });




        // ========================================
        // ANIMATIONS
        // ========================================
        // Module Home hero
        gsap.registerPlugin(ScrollTrigger);

        $('.js_canvas-animation').each(function(index, elt) {
            const eltId = $(elt).attr('id');
            const canvas = document.getElementById(eltId);
            const context = canvas.getContext('2d');

            canvas.width = $(elt).data('image-width');
            canvas.height = $(elt).data('image-height');

            const frameCount = $(elt).data('image-number');
            const currentFrame = index => (
                `/images-canvas/${$(elt).data('name-repertory')}/image-${index.toString().padStart(4, '0')}.png`
            );

            const images = []
            const product = {
                frame: 0
            };

            for (let i = 0; i < frameCount; i++) {
                const img = new Image();
                img.src = currentFrame(i);
                images.push(img);
            }

            gsap.to(product, {
                frame: frameCount - 1,
                snap: "frame",
                ease: "none",
                scrollTrigger: {
                    trigger: elt,
                    start: "top 75%",
                    end: "top 25%",
                    scrub: true,
                },
                onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
            });

            images[0].onload = render;

            function render() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(images[product.frame], 0, 0);
            }
        });


        // Module Keys
        $('.module-keys .list').each(function (index, elt) {
            let tlModuleKeys = gsap.timeline({
                scrollTrigger: {
                    trigger: elt,
                    start: 'top 80%',
                },
            });
            tlModuleKeys
                .to($(elt).find('.item:nth-child(1) .nbr'), 1, {
                    innerText: $(elt).find('.item:nth-child(1) .nbr').data('nbr'),
                    snap: { innerText: 1 },
                })
                .to($(elt).find('.item:nth-child(2) .nbr'), 1.2, {
                    innerText: $(elt).find('.item:nth-child(2) .nbr').data('nbr'),
                    snap: { innerText: 1 },
                }, '-=1')
                .to($(elt).find('.item:nth-child(3) .nbr'), 1.4, {
                    innerText: $(elt).find('.item:nth-child(3) .nbr').data('nbr'),
                    snap: { innerText: 1 },
                }, '-=1.2')
        });


        if ($(window).width() > 1024) {

            // Module icons 3 images
            $('.module-icons-3-images').each(function (index, elt) {
                let tlModuleIcons3Images = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleIcons3Images
                    .from($(elt).find('.list-img .item .illus'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Module Keys
            $('.module-keys .illus-wrapper').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '20em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Icons 1 image
            $('.module-icons-1-image').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Text image style 1
            $('.module-text-image.style-1').each(function (index, elt) {
                gsap.to($(elt).find('.illus-1'), {
                    y: '-4em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
                gsap.to($(elt).find('.illus-2'), {
                    y: '8em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Text image style 2
            $('.module-text-image.style-2').each(function (index, elt) {
                gsap.to($(elt).find('.illus-1, .video'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Text image style 3
            $('.module-text-image.style-3').each(function (index, elt) {
                gsap.to($(elt).find('.desc'), {
                    y: '8em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Cta
            $('.module-cta').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Video
            $('.module-video').each(function (index, elt) {
                let tlModuleVideo = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleVideo
                    .from($(elt).find('.illus'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.075,
                    })
            });


            // Module Download
            $('.module-download').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Certification
            $('.module-certification').each(function (index, elt) {
                let tlModuleCertification = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleCertification
                    .from($(elt).find('.illus'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Module Texts images 2
            $('.module-texts-images-2').each(function (index, elt) {
                gsap.to($(elt).find('.desc'), {
                    yPercent: 45,
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Text background image
            $('.module-text-background-image').each(function (index, elt) {
                gsap.to($(elt).find('.desc'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Slider image vertical
            $('.module-slider-image-vertical').each(function (index, elt) {
                let tlModuleSliderImageVertical = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleSliderImageVertical
                    .from($(elt).find('.illus'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Module Image
            $('.module-image').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Faq
            $('.module-faq').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Module Pricing
            $('.module-pricing .list').each(function (index, elt) {
                let tlModulePricing = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModulePricing
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Module Partner
            $('.module-partner').each(function (index, elt) {
                let tlModulePartner = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModulePartner
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.075,
                    })
            });


            // Module App
            $('.module-app').each(function (index, elt) {
                let tlModuleApp = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleApp
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.075,
                    })
            });


            // Module Timeline
            $('.module-timeline').each(function (index, elt) {
                gsap.from($(elt).find('.list-years'), {
                    duration: .3,
                    x: '-100%',
                    opacity: 0,
                    scrollTrigger: {
                        start: 'top 25%',
                        end: 'bottom 80%',
                        trigger: elt,
                        toggleActions: "restart reverse restart reverse",
                    },
                });
            });
            $('.module-timeline .item').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: '12em',
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        scrub: true
                    },
                });
            });


            // Banner
            $('.banner-page').each(function (index, elt) {
                gsap.to($(elt).find('.background'), {
                    y: $(elt).outerHeight(true) * .5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top top',
                        scrub: true,
                    },
                });
            });


            // Archive page Product
            $('.page-archive-page-products .banner-archive-products').each(function (index, elt) {
                gsap.to($(elt).find('.illus'), {
                    y: $(elt).outerHeight(true) * .5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top top',
                        scrub: true,
                    },
                });
            });


            // Archive Article
            $('.page-archive-article-physio .list-articles-wrapper').each(function (index, elt) {
                let tlPageArchiveArticle = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlPageArchiveArticle
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Single page Product
            $('.page-single-page-product .banner-single-product').each(function (index, elt) {
                gsap.to($(elt).find('.slider-wrapper'), {
                    y: $(elt).outerHeight(true) * .5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top top',
                        scrub: true,
                    },
                });
            });


            // Page Carrefour
            $('.page-carrefour .list-pages-wrapper').each(function (index, elt) {
                let tlPageArchiveArticle = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlPageArchiveArticle
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


            // Home Shop
            $('.module-home-shop').each(function (index, elt) {
                let tlModuleHomeShop = gsap.timeline({
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%',
                    },
                });
                tlModuleHomeShop
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    })
            });


        }

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js